import axios from 'axios';

export default class Posthog {
    constructor() {
        this.api_host = 'https://us.i.posthog.com/i/v0/e/';
        this.api_key = 'phc_4Hokg9ccYRemG73mElezBfPJFzHSqE28ICsCRXhDsB3';
        this.capture_pageview = true;
        this.project_id = 112620;
        this.eventData = {};
    }

    getBrowser() {
        if (typeof navigator === 'undefined') return 'Unknown';
        const ua = navigator.userAgent;
        if (ua.includes('Chrome')) return 'Chrome';
        if (ua.includes('Firefox')) return 'Firefox';
        if (ua.includes('Safari') && !ua.includes('Chrome')) return 'Safari';
        if (ua.includes('Edge')) return 'Edge';
        if (ua.includes('MSIE') || ua.includes('Trident')) return 'Internet Explorer';
        return 'Unknown';
    }

    getBrowserVersion() {
        if (typeof navigator === 'undefined') return 'Unknown';
        const ua = navigator.userAgent;
        const match = ua.match(/(Chrome|Firefox|Safari|Edge|MSIE|Trident)\/?\s*(\d+)/i);
        return match ? match[2] : 'Unknown';
    }

    getOS() {
        if (typeof navigator === 'undefined') return 'Unknown';
        const platform = navigator.platform.toLowerCase();
        const ua = navigator.userAgent.toLowerCase();
        if (platform.includes('win')) return 'Windows';
        if (platform.includes('mac')) return 'MacOS';
        if (platform.includes('linux')) return 'Linux';
        if (/android/.test(ua)) return 'Android';
        if (/iphone|ipad|ipod/.test(ua)) return 'iOS';
        return 'Unknown';
    }

    async capture(eventName = null, additionalData = {}) {
        if (typeof window === 'undefined') {
            console.warn('Posthog capture skipped: not in browser');
            return;
        }

        console.log('capturing', eventName);

        try {
            const now = new Date();
            const current_url = window?.location?.href || null;
            const current_page = typeof document !== 'undefined' ? document.title : null;
            const referrer = typeof document !== 'undefined' ? document.referrer : null;
            const timezone = Intl?.DateTimeFormat()?.resolvedOptions()?.timeZone || null;
            const screen_height = window?.screen?.height || null;
            const screen_width = window?.screen?.width || null;
            const locale = navigator?.language || null;

            const payload = {
                api_key: this.api_key,
                event: eventName,
                $project_id: this.project_id,
                distinct_id: eventName + now.getTime(),
                properties: {
                    $current_url: current_url,
                    $current_page: current_page,
                    $host: window?.location?.hostname || null,
                    $pathname: window?.location?.pathname || null,
                    $referrer: referrer,
                    $referring_domain: referrer ? new URL(referrer).hostname : null,
                    $browser: this.getBrowser(),
                    $browser_version: this.getBrowserVersion(),
                    $os: this.getOS(),
                    $screen_height: screen_height,
                    $screen_width: screen_width,
                    $lib: 'custom-js',
                    $lib_version: '1.0.0',
                    $timezone: timezone,
                    $locale: locale,
                    ...this.eventData,
                    ...additionalData,
                },
            };

            if (window?.posthog) {
                console.log('we have a posthog instance');
                window.posthog.capture(eventName, { ...additionalData });
                return;
            }

            const response = await axios.post(this.api_host, payload, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });

            console.log(response.data);
        } catch (error) {
            console.error('Error sending event:', error.response ? error.response.data : error.message);
        }
    }
}
